import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronRight } from 'lucide-react';

const ResearchersHero = () => {
  return (
    <section className="relative min-h-[80vh] flex items-center text-apple-50 overflow-hidden bg-black pt-[140px] pb-20">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-[10%] left-[15%] w-[35vw] h-[35vw] rounded-full bg-sortio-secondary/20 blur-[120px] animate-float-slow" />
        <div className="absolute bottom-[10%] right-[15%] w-[40vw] h-[40vw] rounded-full bg-sortio-primary/20 blur-[150px] animate-float" />
      </div>

      <div className="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20 text-center">
        <div className="inline-block mb-6">
          <div className="flex items-center justify-center px-4 py-1.5 rounded-full bg-sortio-primary/10 border border-sortio-primary/20">
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">Sortio for Researchers</span>
          </div>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium tracking-tight mb-8 leading-[1.05]">
          AI file organizer for{' '}
          <span className="apple-gradient-text">researchers</span>. Rename PDFs by author and year.
        </h1>

        <p className="text-lg md:text-xl mb-10 text-apple-200 font-light max-w-2xl mx-auto leading-relaxed">
          Sortio renames academic PDFs from content (author, year, title), routes them into project
          folders, and syncs into Zotero collections via the upcoming Zotero integration. Built for
          PhD students, postdocs, principal investigators, and research staff with libraries of
          5,000+ papers and no time to file by hand.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/download" className="apple-button text-base px-8 py-4 flex items-center justify-center">
            Download Free <ArrowRight className="ml-2" size={18} />
          </Link>
          <a href="#contact" className="text-apple-50 hover:text-sortio-primary transition-all px-6 py-3 flex items-center justify-center border border-apple-300/30 rounded-full hover:border-sortio-primary">
            Request a Demo <ChevronRight className="ml-1" size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ResearchersHero;
